var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightingBolt = function SvgLightingBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 60.129"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.616 0 0 35.973h13.281v24.158L40 23.999H26.616z"
  })));
};
export default SvgLightingBolt;